export const invertedMessages = {
  'Actioned By': 'CERTS_ACTIONED_BY',
  'Actioned On': 'CERTS_ACTIONED_ON',
  Comments: 'CERTS_COMMENTS',
  'Cancel Action': 'CERTS_CANCEL_ACTION', // update in script
  'Got it': 'CERTS_REJECT_SECONDARY_BTN',
  'Network Error , Please retry after sometime': 'CERTS_NETWORK_ERROR',
  'Don’t show this again for this certification': 'CONSULT_DONT_SHOW_LABEL',
  'Consultation Requested': 'CERTS_CONSULTATION_REQUESTED',
  'You can wait for responses to your consultations, consult with other peers, or go ahead and make decisions. Once all decisions are made, you can review and submit your certification.':
    'CERTS_CONSULTATION_INFO',

  // Reassign Popover messages
  User: 'User_LABEL.ATTESTATIONS',
  Account: 'Account_LABEL.ATTESTATIONS',
  Role: 'Role_LABEL.ATTESTATIONS',
  Entitlement: 'Ent_LABEL.ATTESTATIONS',
  'Child Entitlement': 'Ent2_LABEL.ATTESTATIONS',
  'By reassigning this {lineItem}, their associated items will be included. Any approvals or rejections will be cleared upon reassignment.':
    'CERTS_REASSIGN_TITLE',
  Cancel: 'CERTS_CANCEL',
};
